/**
 * Stable test ids for the event-wizard chrome. Single source of truth shared by
 * the React source (renders `data-testid`) and the Playwright suite (`getByTestId`).
 *
 * Gating is automatic: the babel strip plugin removes every `data-testid` JSX
 * attribute from prod builds, so these survive only in the test bundle.
 *
 * Seams in use:
 *  - input-field-v2 forwards `inputTestId` to its <input> (name / online-venue / host name+email / custom link).
 *  - ClickableDiv + Button forward `data-testid` to their root (venue summary card, footer primary CTA, my-designs card, add-custom-link).
 *  - ControlledAccordion forwards `data-testid` to its header ClickableDiv (the review-section accordions).
 */
export enum EventWizardTestId {
  // input-field-v2 inputTestId → inner <input>.
  EVENT_NAME_INPUT = 'EVENT_NAME_INPUT',
  ONLINE_VENUE_INPUT = 'ONLINE_VENUE_INPUT',
  HOST_NAME_INPUT = 'HOST_NAME_INPUT',
  HOST_EMAIL_INPUT = 'HOST_EMAIL_INPUT',
  // ClickableDiv / Button data-testid → root.
  VENUE_SUMMARY_CARD = 'VENUE_SUMMARY_CARD',
  FOOTER_PRIMARY_BUTTON = 'FOOTER_PRIMARY_BUTTON',
  MEDIA_MY_DESIGNS = 'MEDIA_MY_DESIGNS',
  // The location modal's Done button (the location opens as a modal on small screens and in the embedded wizard).
  VENUE_MODAL_DONE_BUTTON = 'VENUE_MODAL_DONE_BUTTON',
  // ControlledAccordion data-testid → header ClickableDiv (carries the open-state class).
  DETAILS_ACCORDION = 'DETAILS_ACCORDION',
  ORGANIZER_ACCORDION = 'ORGANIZER_ACCORDION',
}
